<template src="./html/Datatable.html"></template>

<script>
	import Ladda from 'ladda'
	import swal from 'sweetalert2'
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
	import FilterBar from './FilterBar'
	import VueElementLoading from 'vue-element-loading'
	import ChangeStatus from './ChangeStatus'
	import Actions from './Actions'
	import Assigned from './Assigned'
	import _ from 'lodash'
	
	export default {
		props: ['user', 'isAuth', 'customer', 'project'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,
			'filter-bar': FilterBar,
			'loading': VueElementLoading,
			'change-status': ChangeStatus,
			'actions': Actions,
			'assigned': Assigned,
		},
		created() {
			this.init()
		},
		mounted() {
			this.$events.$on('filterSet', eventData => this.filterSet(eventData))
			this.$events.$on('filterReset', eventData => this.filterReset(eventData))
		},
		data () {
			return {
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/management/budgets/datatable',
					loading: true,
					moreParams: {
						filter: {
							allowDate: false,
							date: null,
							text: null,
							assigned_to: null,
							budget_status_id: null,
							customer_id: null,
							project_id: null,
						}
					},
					page: 20,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						}
					],
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							name: '__slot:id',
							title: this.$platform.setting.number_symbol,
							sortField: 'id',
						},
						{
							name: '__slot:read',
							title: 'Visto',
						},
						{
							name: '__slot:title',
							title: 'Título',
							sortField: 'title',
						},
						{
							name: '__slot:customer',
							title: 'Cliente',
						},
						{
							name: '__slot:status',
							title: 'Estado',
							sortField: 'budget_status_id',
						},
						{
							name: '__slot:base_amount',
							title: 'Precio',
							sortField: 'base_amount',
							visible: false,
						},
						{
							name: 'discount',
							title: 'Dto.',
							sortField: 'discount',
							visible: false,
						},
						{
							name: '__slot:save',
							title: 'Ahorro',
							sortField: 'save',
							visible: false,
						},
						{
							name: '__slot:amount',
							title: 'Base imponible',
							sortField: 'amount',
						},
						{
							name: '__slot:taxes',
							title: 'Impuestos',
							sortField: 'taxes',
						},
						{
							name: '__slot:total',
							title: 'Total',
							sortField: 'total',
						},
						{
							name: '__slot:assigned',
							title: 'Agente',
						},
						{
							name: '__slot:author',
							title: 'Autor',
							visible: false,
						},
						{
							name: 'created_at',
							title: 'Fecha',
							callback: function(value) {
								return moment(value).format('DD/MM/YY')
							},
							sortField: 'created_at',
						},
						{
							name: '__slot:actions',
							title: '',
						}
					],
				},

				statuses: null,
			}
		},
		watch: {
			'$route'() {
				this.loadQuery()
				this.reload()
			}
		},
		methods: {
			init() {
				this.getStatuses()
				this.loadQuery()
				if(this.customer) {
					this.datatable.moreParams.filter.customer_id = this.customer.id
				}
				if(this.project) {
					this.datatable.moreParams.filter.project_id = this.project.id
				}
			},
			loadQuery() {
				if(this.$route.query) {
					if(this.$route.query.text) {
						this.datatable.moreParams.filter.text = this.$route.query.text
					}
					if(this.$route.query.date) {
						this.datatable.moreParams.filter.allowDate = true
						this.datatable.moreParams.filter.date = this.$route.query.date
					}
				}
			},
			getStatuses() {
				this.$http.get('admin/management/budgets/statuses')
					.then(response => {
						this.statuses = response.body
					})
			},
			reload() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				this.datatable.loading = false
				this.loadDropdowns()
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			filterSet: _.debounce(function (filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			}, 300),
			filterReset(filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			},
			//--
			loadDropdowns() {
				$('.table-responsive').on('show.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "inherit" )
				});

				$('.table-responsive').on('hide.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "auto" )
				})
			},
			editOrContinue(response) {
				var that = this
				swal({
					title: response.body.title,
					text: response.body.text,
					type: response.body.type,
					showCancelButton: true,
					confirmButtonColor: '#2cabe3',
					confirmButtonText: 'Editar',
					cancelButtonText: 'Continuar',
				}).then(function () {
					that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/budgets/' + response.body.data.id + '/edit')
				}).catch()
			},
			create () {
				var loading = Ladda.create(this.$refs.btnCreate)
				loading.start()
				this.$http.post('admin/management/budgets')
				.then(response => {
					this.$refs.datatable.reload()
					var budget = response.body.data
					loading.stop()
					this.editOrContinue(response)
				}).catch(function(response) {
					loading.stop()
					console.log(response)
				})
			},
			changeStatus(data) {
				var select = document.querySelector('#select-statuses-budget-' + data.id)
				select.setAttribute('disabled', true)
				this.$http.get('admin/management/budgets/' + data.id + '/change/status/' + data.budget_status_id)
					.then(response => {
						select.removeAttribute('disabled')
						this.reload()
					}).catch(response => {
						select.removeAttribute('disabled')
						if(response.status == 409) {
							swal({
								title: response.statusText,
								text: response.body,
								type: 'warning',
							})
						}
						this.reload()
					})
			},
			duplicate(data) {
				var that = this
				swal.queue([{
						title: this.$t("messages.attention"),
						text: "Se duplicará el presupuesto",
						type: "warning",
						showCancelButton: true,
						confirmButtonColor: "#53e69d",
						cancelButtonColor: "#ff7676",
						confirmButtonText: "Si",
						cancelButtonText: "No",
						showLoaderOnConfirm: true,
						preConfirm: function () {
							return new Promise(function (resolve) {
								that.$http.get('admin/management/budgets/' + data.id + '/duplicate')
								.then(response => {
									that.reload()
									that.editOrContinue(response)
								}).catch(function(response) {
									that.loading = false
									console.log(response)
								})
							})
						}
					}]).catch(swal.noop)
			},
			destroy: function(budget) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/management/budgets/' + budget.id)
							.then(response => {
								that.reload()
								that.$emit('reload')
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								if(response.status == 409) {
									swal(response.body.title, response.body.text, response.body.type);
								} else {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/budgets/views/Datatable.vue